"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInput = exports.Converter = exports.Handler = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var AddressInput_st_css_1 = require("./AddressInput.st.css");
var InputWithOptions_1 = require("../input-with-options/InputWithOptions");
var intersection_1 = require("../../utils/intersection");
var dropdown_option_1 = require("../dropdown-option");
var types_1 = require("../../clients/GoogleMaps/types");
Object.defineProperty(exports, "Handler", { enumerable: true, get: function () { return types_1.Handler; } });
var google2address_1 = require("../../clients/GoogleMaps/google2address/google2address");
var filter_data_props_1 = require("../../utils/filter-data-props");
var first = require('lodash/first');
var throttle = require('lodash/throttle');
var isArray = require('lodash/isArray');
var Converter;
(function (Converter) {
    Converter["full"] = "full";
    Converter["simple"] = "simple";
})(Converter = exports.Converter || (exports.Converter = {}));
function filterAddressesByType(addresses, filterTypes) {
    return filterTypes && filterTypes.length > 0
        ? (addresses || []).filter(function (address) { return intersection_1.intersection(address.types, filterTypes).length > 0; })
        : addresses;
}
function formatAtlasAddressOutput(atlasAddress, description) {
    return {
        originValue: description,
        googleResult: {},
        address: atlasAddress,
    };
}
function formatAddressOutput(google, description, rawInputValue, converterType) {
    google2address_1.trySetStreetNumberIfNotReceived(google, rawInputValue);
    var converter = converterType === Converter.full
        ? google2address_1.convertToFullAddress
        : google2address_1.convertToPartialAddress;
    return {
        originValue: description,
        googleResult: google,
        address: converter(google),
    };
}
function createAutocompleteRequest(input, props) {
    var countryCode = props.countryCode, types = props.types;
    var result = { input: input };
    if (typeof countryCode === 'string') {
        result.componentRestrictions = { country: countryCode.toLowerCase() };
    }
    if (types) {
        result.types = types;
    }
    return result;
}
/**
 * AddressInput
 */
var AddressInput = /** @class */ (function (_super) {
    tslib_1.__extends(AddressInput, _super);
    function AddressInput(props) {
        var _this = _super.call(this, props) || this;
        _this.unmounted = false;
        _this.optionWasSelected = false;
        _this.addressRequestId = 0;
        _this.geocodeRequestId = 0;
        _this.placeDetailsRequestId = 0;
        _this._getAddressOptions =
            props.throttleInterval === 0
                ? _this._getAddressOptions.bind(_this)
                : throttle(_this._getAddressOptions, props.throttleInterval);
        _this._handleOnChange = _this._handleOnChange.bind(_this);
        _this._handleOnManualInput = _this._handleOnManualInput.bind(_this);
        _this._onSelect = _this._onSelect.bind(_this);
        _this._handleOnBlur = _this._handleOnBlur.bind(_this);
        _this._renderOption = _this._renderOption.bind(_this);
        _this._createOptionFromAddress = _this._createOptionFromAddress.bind(_this);
        _this._handleContentMouseDown = _this._handleContentMouseDown.bind(_this);
        _this.currentAddressRequest = Promise.resolve();
        _this.state = { options: [], inputValue: props.value || '', isDirty: false };
        return _this;
    }
    AddressInput.prototype.componentDidMount = function () {
        var _a = this.props, clientId = _a.clientId, Client = _a.Client, instance = _a.instance, lang = _a.lang, externalBaseUrl = _a.externalBaseUrl, locale = _a.locale;
        this.client = new Client({ lang: lang, locale: locale, instance: instance, externalBaseUrl: externalBaseUrl });
        if (this.client.name === 'google' && clientId) {
            this.client.useClientId();
        }
    };
    AddressInput.prototype.componentWillUnmount = function () {
        this.unmounted = true;
    };
    AddressInput.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        // If user interacted, meaning the value is "dirty",
        // we want to update it in any case.
        if (nextProps.value !== this.props.value || this.state.isDirty) {
            this.setState({ inputValue: nextProps.value, isDirty: false });
        }
    };
    AddressInput.prototype.focus = function () {
        this.inputRef.focus();
    };
    AddressInput.prototype.blur = function () {
        this.inputRef.blur();
    };
    AddressInput.prototype.close = function () {
        this.inputWithOptionsRef.close();
    };
    AddressInput.prototype.clear = function () {
        this.setState({ inputValue: '', options: [] });
    };
    AddressInput.prototype._getKey = function () {
        return this.props.clientId || this.props.apiKey;
    };
    AddressInput.prototype._getAddressOptions = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestId, resolveCurrentAddressRequest, _a, lang, filterTypes, results, filteredResults, options;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestId = ++this.addressRequestId;
                        this.currentAddressRequest = new Promise(function (resolve) { return (resolveCurrentAddressRequest = resolve); });
                        _a = this.props, lang = _a.lang, filterTypes = _a.filterTypes;
                        return [4 /*yield*/, this.client.autocomplete(this._getKey(), lang, createAutocompleteRequest(input, this.props))];
                    case 1:
                        results = _b.sent();
                        filteredResults = filterAddressesByType(results, filterTypes) || [];
                        options = filteredResults.map(this._createOptionFromAddress);
                        if (!this.unmounted && requestId === this.addressRequestId) {
                            this.setState({ options: options }, resolveCurrentAddressRequest);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._getGeocode = function (placeId, description, rawInputValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestId, _a, lang, region, converterType, instance, request, geocode, formatByProvider;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestId = ++this.geocodeRequestId;
                        _a = this.props, lang = _a.lang, region = _a.countryCode, converterType = _a.converterType, instance = _a.instance;
                        request = placeId ? { placeId: placeId, region: region } : { address: rawInputValue };
                        return [4 /*yield*/, this.client.geocode(this._getKey(), lang, request)];
                    case 1:
                        geocode = _b.sent();
                        formatByProvider = this.client.name === 'atlas'
                            ? formatAtlasAddressOutput
                            : formatAddressOutput;
                        if (requestId === this.geocodeRequestId) {
                            this._invokeOnSelect(formatByProvider(first(geocode), description, rawInputValue, converterType));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._getPlaceDetails = function (placeId, description, rawInputValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestId, _a, lang, converterType, placeDetails;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.client.name === 'google')) return [3 /*break*/, 2];
                        requestId = ++this.placeDetailsRequestId;
                        _a = this.props, lang = _a.lang, converterType = _a.converterType;
                        return [4 /*yield*/, this.client.placeDetails(this._getKey(), lang, {
                                placeId: placeId,
                            })];
                    case 1:
                        placeDetails = _b.sent();
                        if (requestId === this.placeDetailsRequestId) {
                            this._invokeOnSelect(formatAddressOutput(placeDetails, description, rawInputValue, converterType));
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._invokeOnSelect = function (value) {
        if (!this.unmounted) {
            this.setState({ isDirty: true });
            this.props.onSelect(value);
        }
    };
    AddressInput.prototype._forceSelectIfNeeded = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var forceSelect, options, firstOption, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        forceSelect = this.props.forceSelect;
                        if (!forceSelect) return [3 /*break*/, 4];
                        options = this._options();
                        firstOption = options.length ? first(options) : null;
                        if (!(!this.optionWasSelected && firstOption)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._onSelect(firstOption)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._handleClientError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._onSelect = function (option) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var handler, inputValue, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        handler = this.props.handler;
                        inputValue = this.state.inputValue;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 9, , 10]);
                        if (!(!option && !inputValue)) return [3 /*break*/, 2];
                        this._invokeOnSelect(null);
                        return [3 /*break*/, 8];
                    case 2:
                        if (!!option) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._getGeocode(null, null, inputValue)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(handler === types_1.Handler.geocode && option)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._getGeocode(option.id, option.value, inputValue)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        if (!(handler === types_1.Handler.places)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this._getPlaceDetails(option.id, option.value, inputValue)];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_2 = _a.sent();
                        this._handleClientError(e_2);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._handleOnChange = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var onChange, value, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onChange = this.props.onChange;
                        value = e.target.value;
                        this.optionWasSelected = false;
                        onChange && onChange(e);
                        this.setState({ inputValue: value });
                        if (!value) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._getAddressOptions(value)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        this._handleClientError(e_3);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({ options: [] });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._handleClientError = function (e) {
        var onError = this.props.onError;
        this.setState({ options: [] });
        if (onError) {
            onError(e);
        }
        else {
            throw e;
        }
    };
    AddressInput.prototype._handleOnManualInput = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, onManualInput, fallbackToManual, e_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, onManualInput = _a.onManualInput, fallbackToManual = _a.fallbackToManual;
                        onManualInput && onManualInput(value);
                        return [4 /*yield*/, this.currentAddressRequest];
                    case 1:
                        _b.sent();
                        if (!(fallbackToManual && this.state.options.length === 0)) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this._onSelect(null)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_4 = _b.sent();
                        this._handleClientError(e_4);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._handleOnBlur = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, clearSuggestionsOnBlur, onBlur;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, clearSuggestionsOnBlur = _a.clearSuggestionsOnBlur, onBlur = _a.onBlur;
                        return [4 /*yield*/, this._forceSelectIfNeeded()];
                    case 1:
                        _b.sent();
                        onBlur && onBlur();
                        if (clearSuggestionsOnBlur) {
                            this.setState({ options: [] });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddressInput.prototype._handleContentMouseDown = function (e) {
        this.optionWasSelected = true;
        e.preventDefault(); // Prevent input blur
    };
    AddressInput.prototype._renderOption = function (val) {
        var _a = this.props, locationIcon = _a.locationIcon, optionStyle = _a.optionStyle;
        return (React.createElement("div", { className: AddressInput_st_css_1.classes.option, style: optionStyle },
            locationIcon && (React.createElement("div", { className: AddressInput_st_css_1.classes.iconWrapper, "data-hook": "location-icon-wrapper" }, locationIcon)),
            React.createElement("div", { className: AddressInput_st_css_1.classes.optionContent }, val)));
    };
    AddressInput.prototype._createOptionFromAddress = function (address) {
        return dropdown_option_1.OptionFactory.create({
            id: address.place_id,
            value: address.description,
            render: this._renderOption,
        });
    };
    AddressInput.prototype._options = function () {
        var forceOptions = this.props.forceOptions;
        if (isArray(forceOptions) && forceOptions.length > 0) {
            return forceOptions.map(this._createOptionFromAddress);
        }
        return this.state.options;
    };
    AddressInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, placement = _a.placement, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, forceContentElementVisibility = _a.forceContentElementVisibility, emptyStateMessage = _a.emptyStateMessage, readOnly = _a.readOnly, disabled = _a.disabled, inlineStyles = _a.style, prefix = _a.prefix, suffix = _a.suffix, fixedFooter = _a.fixedFooter, id = _a.id, inputStyle = _a.inputStyle, flip = _a.flip, fixed = _a.fixed, optionStyle = _a.optionStyle, moveBy = _a.moveBy, inputClassName = _a.inputClassName, optionsContainerZIndex = _a.optionsContainerZIndex, className = _a.className, appendTo = _a.appendTo, dynamicWidth = _a.dynamicWidth;
        var options = this._options();
        var inputProps = {
            'aria-label': this.props['aria-label'],
            onChange: this._handleOnChange,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: this._handleOnBlur,
            placeholder: placeholder,
            readOnly: readOnly,
            disabled: disabled,
            value: this.state.inputValue,
            prefix: prefix,
            suffix: suffix,
            ref: function (ref) { return (_this.inputRef = ref); },
            onClick: this.props.onClick,
            onDoubleClick: this.props.onDoubleClick,
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave,
            style: inputStyle,
            inputClassName: inputClassName,
            required: this.props.required,
            autoComplete: 'off',
            type: 'search',
        };
        var states = {};
        var hasOptions = options.length > 0;
        var timeout = hasOptions ? 150 : 0;
        return (React.createElement(InputWithOptions_1.InputWithOptions, tslib_1.__assign({ className: AddressInput_st_css_1.st(AddressInput_st_css_1.classes.root, states, className), onContentMouseDown: this._handleContentMouseDown, onSelect: this._onSelect, options: options, inputProps: inputProps, placement: placement, onManualInput: this._handleOnManualInput, timeout: timeout, forceContentElementVisibility: forceContentElementVisibility, style: inlineStyles, fixedFooter: hasOptions && fixedFooter, id: id, ref: function (ref) { return (_this.inputWithOptionsRef = ref); }, allowReselect: true, filterPredicate: function () { return true; }, flip: flip, fixed: fixed, moveBy: moveBy, emptyStateMessage: emptyStateMessage, emptyStateStyle: optionStyle, optionsContainerZIndex: optionsContainerZIndex, appendTo: appendTo, dynamicWidth: dynamicWidth }, filter_data_props_1.filterDataProps(this.props))));
    };
    AddressInput.displayName = 'AddressInput';
    AddressInput.defaultProps = {
        handler: types_1.Handler.geocode,
        throttleInterval: 150,
        lang: 'en',
        locale: 'en-US',
        converterType: Converter.full,
        required: false,
    };
    return AddressInput;
}(React.PureComponent));
exports.AddressInput = AddressInput;
//# sourceMappingURL=AddressInput.js.map